import { ManufacturingLifecycleStatus } from '../../constants/manufacturing-lifecycle-status.js';
/** Header and line edits are both Draft-only — the one list every draft-gated MO mutation reads. */
export const MANUFACTURING_ORDER_EDITABLE_STATUS_IDS = [
    ManufacturingLifecycleStatus.DRAFT,
];
//# sourceMappingURL=editable-status-ids.js.map